import { Badge, Card, EmptyState, PageHeader } from '@cartly/ui';
import { Link } from 'react-router';
import { CURRENT_PHASE, type NavItem } from '../app/nav';

/**
 * Shown for modules that are planned but not built yet, so the navigation reflects the full
 * product without presenting fake data.
 */
export function ModulePage({ item }: { item: NavItem }) {
  const Icon = item.icon;
  return (
    <>
      <PageHeader
        title={
          <span className="row">
            {item.label} <Badge tone="info">Phase {item.phase}</Badge>
          </span>
        }
        description={item.description}
      />
      <Card>
        <EmptyState
          icon={<Icon size={22} />}
          title={`${item.label} isn't available yet`}
          action={
            <Link to="/" className="btn btn--secondary">
              Back to overview
            </Link>
          }
        >
          This module is scheduled for phase {item.phase} of the build. The current release covers
          phases 1 to {CURRENT_PHASE}: accounts and team access, store connections and commerce
          sync, WhatsApp messaging and campaigns, and automation flows.
        </EmptyState>
      </Card>
    </>
  );
}
